import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout/Layout'
import { useSelector } from './store'
import Login from './pages/Login/Login'
import ExclusionRules from './pages/ExclusionRules/ExclusionRules'
import ReplacementRules from 'pages/ReplacementRules/ReplacementRules'
import PriceTypes from 'pages/PriceTypes/PriceTypes'
import Exceptions from './pages/Exceptions/Exceptions'
import WorkerTasks from './pages/WorkerTasks/WorkerTasks'
import Makes from './pages/Makes/Makes'
import Models from './pages/Models/Models'
import VinMaps from './pages/VinMaps/VinMaps'
import Logs from './pages/Logs/Logs'
import FeedMonitor from './pages/FeedMonitor/FeedMonitor'
import KibanaDashboard from './pages/KibanaDashboard/KibanaDashboard'
import EntityLogs from './pages/EntityLogs/EntityLogs'
import CorrelationAudit from './pages/CorrelationAudit/CorrelationAudit'
import CorrelationAuditDetails from './pages/CorrelationAudit/CorrelationAuditDetails'
import AdminDashboard from './pages/AdminDashboard/AdminDashboard'
import Insights from './pages/Insights/Insights'

const AuthRouter = () => (
  <Routes>
    <Route path={'/login'} element={<Login />} />
    <Route path={'*'} element={<Navigate to="/login" />} />
  </Routes>
)

const AppRouter = () => {
  // Get the intended path from session storage (saved before auth check)
  const intendedPath = sessionStorage.getItem('intendedPath') || '/exceptions'
  // Clear it after reading so it doesn't persist across sessions
  sessionStorage.removeItem('intendedPath')

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path={'/'} element={<Navigate to={intendedPath} replace />} />
        <Route path={'/login'} element={<Navigate to={intendedPath} replace />} />
        <Route path={'/exceptions'} element={<Exceptions />} />
        <Route path={'/exclusion_rule'} element={<ExclusionRules />} />
        <Route path={'/vin_maps'} element={<VinMaps />} />
        <Route path={'/replacement_rules'} element={<ReplacementRules />} />
        <Route path={'/price_types'} element={<PriceTypes />} />
        <Route path={'/makes_list'} element={<Makes />} />
        <Route path={'/models_list'} element={<Models />} />
        {/* <Route path={'/logs_explorer'} element={<Logs />} /> */}
        <Route path={'/worker_tasks'} element={<WorkerTasks />} />
        <Route path={'/feed_monitor'} element={<FeedMonitor />} />
        <Route path={'/kibana_dashboard'} element={<KibanaDashboard />} />
        <Route path={'/entity_logs'} element={<EntityLogs />} />
        <Route path={'/correlation_audit'} element={<CorrelationAudit />} />
        <Route path={'/correlation_audit/:correlationId'} element={<CorrelationAuditDetails />} />
        <Route path={'/insights'} element={<Insights />} />
        <Route path={'/ops'} element={<AdminDashboard />} />
        <Route path={'*'} element={<h1>404</h1>} />
      </Route>
    </Routes>
  )
}

const Router = () => {
  const isAuth = useSelector((state) => state.profile.isAuth)

  if (isAuth) return <AppRouter />
  else return <AuthRouter />
}

export default Router
